// Preload only the existing summary image. Speculative IDX detail/media reads
// spend the visitor request allowance before the visitor opens a home.
const warmedImages = new Set();
export const warmPropertyDetail = (property) => {
  if (typeof navigator !== 'undefined' && navigator.connection?.saveData) return;
  const url = property?.first_photo_url;
  if (url && !warmedImages.has(url)) {
    warmedImages.add(url);
    const image = new Image();
    image.src = url;
  }
};
export const warmPropertyBatch = (properties, limit) => {
  const rows = Array.isArray(properties) ? properties : [];
  (typeof limit === 'number' ? rows.slice(0, limit) : rows).forEach(warmPropertyDetail);
};
